
















































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import FormAuthorization from "@/mixins/FormAuthorization";
import SkriningPaliatifDewasaService from "@/services/SkriningPaliatifDewasa";
import CardSkriningPaliatifDewasa from "@/components/pemeriksaan/assesmen/skriningpaliatifdewasa/CardSkriningPaliatifDewasa.vue";

/**
 * Daftar Skrining Paliatif Dewasa per encounter.
 *
 * Tanpa alur TTD digital — blanko sumber RSPS tidak memuat blok tanda tangan.
 * Pengaman perubahan mengikuti kebijakan baku EMR: read-only 48 jam pasca
 * keluar (ditegakkan server lewat EnforcesEditWindow) + hanya pembuat catatan
 * yang boleh mengubah/menghapus.
 */
@Component({
  components: { CardSkriningPaliatifDewasa },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class SkriningPaliatifDewasaPage extends Mixins(
  FormAuthorization
) {
  @Prop() register!: string;
  @Prop() rm!: string;
  /** "ralan" (panel Skrining Ralan) atau "ranap" (tab Rekam Medis Ranap). */
  @Prop({ default: "ralan" }) encounterType!: string;
  /**
   * Diisi host bertab (Ranap) agar daftar dimuat ulang saat tab dibuka —
   * di Ralan (expansion panel) prop ini tidak dipakai dan datanya dimuat
   * sekali di mounted.
   */
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Tanggal", value: "tanggal_skrining" },
    { text: "Total Skor", value: "skor_total", sortable: false },
    { text: "Hasil", value: "kategori_hasil", sortable: false },
    { text: "Dicatat oleh", value: "pencatat", sortable: false },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  loadingList = false;
  editItem = null;
  listData = [];
  expanded = [];
  itemLabels: { [k: string]: string } = {};

  mounted() {
    this.loadLabels();
    this.getByRegister();
  }

  @Watch("isActive")
  onIsActiveChange(val: boolean) {
    if (val) this.getByRegister();
  }

  /** Label kriteria diambil dari master server (sumber tunggal). */
  loadLabels() {
    SkriningPaliatifDewasaService.masters().then(resp => {
      if (!resp || !resp.data) return;
      const map: { [k: string]: string } = {};
      (resp.data.kriteria || []).forEach(g => {
        if (g.tipe !== "checkbox") return;
        (g.items || []).forEach(i => (map[i.code] = i.label));
      });
      this.itemLabels = map;
    });
  }

  getByRegister() {
    this.loadingList = true;
    SkriningPaliatifDewasaService.getByRegister(this.register)
      .then(resp => {
        if (resp && resp.data) this.listData = resp.data;
      })
      .finally(() => {
        this.loadingList = false;
      });
  }

  onSaved() {
    this.getByRegister();
  }

  itemLabel(code) {
    return this.itemLabels[code] || code;
  }

  getKategoriColor(kategori) {
    const map = {
      tidak_perlu: "green",
      observasi: "amber darken-2",
      perlu_intervensi: "red"
    };
    return map[kategori] || "grey";
  }

  edit(item) {
    if (this.validateUserEdit(item.creator_user_id)) {
      this.editItem = JSON.parse(JSON.stringify(item));
    }
  }

  remove(item) {
    if (
      this.validateUserEdit(item.creator_user_id) &&
      confirmRemove("Skrining Paliatif Dewasa")
    ) {
      SkriningPaliatifDewasaService.destroy(item.id).then(() => {
        appModule.NoticeDelay("Berhasil menghapus skrining");
        this.editItem = null;
        this.getByRegister();
      });
    }
  }

  printPdf(id) {
    SkriningPaliatifDewasaService.printPdf(id);
  }

  markDone(item, tl) {
    SkriningPaliatifDewasaService.markTindakLanjut(item.id, tl.id, {
      status: "done"
    }).then(resp => {
      if (resp && resp.status == "1") {
        appModule.NoticeDelay("Tindak lanjut ditandai selesai");
        this.getByRegister();
      }
    });
  }
}
